import { ExploreMetrics } from '~/declarations/toggle-api-explore.d';
import { ENDPOINT_URLS } from '~/global/toggle-api';
import { APIFetch } from '~/shared/services/api-fetch/APIFetch';

export async function fetchExploreMetrics(): Promise<ExploreMetrics | Error> {
  return APIFetch<ExploreMetrics>(ENDPOINT_URLS.EXPLORE_METRICS);
}
